export default __webpack_public_path__ + "static/media/i062jk.a396d087.webp";